/* global bocAmchart */

/**
 * Adds the chart titles if the titles from group meta data if titles were not added manually
 *
 * @param {object} data Object containing the valet data sets
 * @param {object} chart object
 * @returns {void}
 */
bocAmchart.getChartTitlesFromGroup = function (data, chart) {

    if ((!chart.hasOwnProperty("titles") || Object.keys(chart.titles).length === 0)
        && data.hasOwnProperty("groupDetail")) {
        chart.titles = [];

        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.log(
                chart.bocSettings.id,
                "Adding titles from group metadata",
                ":",
                data.groupDetail.label,
                data.groupDetail.description
            );
        }

        bocAmchart.addChartTitle(chart, 'charttitle', data.groupDetail.label);
        bocAmchart.addChartTitle(chart, 'subtitle', data.groupDetail.description);
    }
};
